import { Mark } from '@tiptap/core';

export const InlineThreadMark = Mark.create({
  name: 'inlineThread',
  excludes: '',
  inclusive: false,
  keepOnSplit: true,
  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },
  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (element: HTMLHtmlElement) =>
          element.getAttribute('data-inline-thread-id'),
        renderHTML: (attributes: { id: string | null }) => {
          if (!attributes.id) {
            return {};
          }

          return {
            'data-inline-thread-id': attributes.id,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-inline-thread-id]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', { ...this.options.HTMLAttributes, ...HTMLAttributes }, 0];
  },
});
